import { unFormatCurrency } from '@/common/utils/unFormatters'
import { z } from 'zod'

export const updateGovernmentAllocationApprovedValueSchema = z.object({
  approved_value: z.string().refine(
    (value) => {
      if (!value) return false
      return unFormatCurrency(value) >= 0
    },
    { message: 'Campo obrigatório' },
  ),
})

export type UpdateGovernmentAllocationApprovedValueSchema = z.infer<
  typeof updateGovernmentAllocationApprovedValueSchema
>
